module.exports = __webpack_public_path__ + "img/deviceBorrow-mine-bar-5.c565652b.png";